import * as React from 'react';
import {BaseIconProps} from '../../types';

export const BaseWarning: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0694 4.2153C12.583 3.41163 11.4171 3.41163 10.9306 4.2153L2.97897 17.3528C2.47475 18.1859 3.07457 19.2501 4.04835 19.2501H19.9517C20.9254 19.2501 21.5253 18.1859 21.021 17.3528L13.0694 4.2153ZM9.64738 3.43859C10.7175 1.67053 13.2825 1.67053 14.3526 3.43859L22.3043 16.5761C23.4136 18.4089 22.094 20.7501 19.9517 20.7501H4.04835C1.90604 20.7501 0.586431 18.4089 1.69572 16.5761L9.64738 3.43859ZM12 7.25006C12.4142 7.25006 12.75 7.58585 12.75 8.00006V13.0001C12.75 13.4143 12.4142 13.7501 12 13.7501C11.5858 13.7501 11.25 13.4143 11.25 13.0001V8.00006C11.25 7.58585 11.5858 7.25006 12 7.25006ZM12 17.0001C12.5523 17.0001 13 16.5523 13 16.0001C13 15.4478 12.5523 15.0001 12 15.0001C11.4477 15.0001 11 15.4478 11 16.0001C11 16.5523 11.4477 17.0001 12 17.0001Z"
        fill={color}
      />
    </svg>
  );
};
